export const SOCIAL_MEDIA_LINKS = {
    facebook: "https://www.facebook.com/suarezlemusabogadas",
    linkedin: "https://www.linkedin.com/company/livespainvisa-consulting/?viewAsMember=true",
    instagram: "https://www.instagram.com/livespainvisa?igsh=MTR4YXdnbzF5N3V5&utm_source=qr",
};
